import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import styles from './MobileMenuItem.scss';
import offersCategory from '../offers-category';
import notifyAnalytics from '../notify-analytics';
import formatTestId from '../../../utils/test-id/format-testid';

const MobileMenuItem = ({
  label,
  url,
  className,
  onClick,
  child,
  hierarchy: parentHierarchy,
  children,
  isBrandPromiseActive,
}) => {
  const isButton = child?.length > 0;
  const isAnchor = url && !isButton;
  const isOffer = offersCategory(label, 1);
  const offersChildren = child?.filter(item => !!item.url) || [];
  const hierarchy = [...parentHierarchy, label];

  const sendAnalytics = (tail = []) => {
    notifyAnalytics([...hierarchy, ...tail].join('|'));
  };

  const advanceToChild = e => {
    sendAnalytics();
    onClick(e);
  };

  if (!isAnchor && !isButton) {
    return <></>;
  }

  return (
    <li
      className={classNames(styles.mobileMenuItem, className, {
        [styles.mobileMenuItem__bp]: isBrandPromiseActive,
      })}
    >
      {isAnchor && (
        <a
          href={url}
          className={styles.mobileMenuItem__link}
          onClick={() => sendAnalytics()}
          data-testid={formatTestId(label, 'nav-')}
          data-hierarchy={parentHierarchy.join('|')}
        >
          {label}
        </a>
      )}
      {isButton && (
        <button
          onClick={advanceToChild}
          data-testid={formatTestId(label, 'nav-')}
          className={classNames(
            styles.mobileMenuItem__button,
            styles.mobileMenuItem__chevron,
            {
              [styles.offersLabel]: isOffer,
            }
          )}
        >
          {label}
        </button>
      )}
      {isOffer && offersChildren.length > 0 && (
        <ul className={styles.offersSubMenu}>
          {offersChildren.slice(0, 3).map(nestedItem => (
            <li className={styles.mobileMenuItem} key={nestedItem.name}>
              <a
                className={styles.mobileMenuItem__link}
                onClick={() => sendAnalytics([nestedItem.name])}
                href={nestedItem.url}
              >
                {nestedItem.name}
              </a>
            </li>
          ))}
          {offersChildren.length > 3 && (
            <li
              className={classNames(styles.mobileMenuItem, styles.viewMoreLink)}
            >
              <button
                className={styles.mobileMenuItem__button}
                onClick={advanceToChild}
              >
                View more
              </button>
            </li>
          )}
        </ul>
      )}
      {children}
    </li>
  );
};

MobileMenuItem.defaultProps = {
  url: '',
  className: '',
  onClick: undefined,
  child: undefined,
  hierarchy: [],
  children: undefined,
};

MobileMenuItem.propTypes = {
  label: PropTypes.string.isRequired,
  url: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  child: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      url: PropTypes.string,
    })
  ),
  hierarchy: PropTypes.arrayOf(PropTypes.string),
  children: PropTypes.node,
};

export default MobileMenuItem;
